export default "__VITE_ASSET__2bc4cd6f__"